import { styled } from "styled-components";

import { AchievementType } from "@/interfaces/api";

import { getLevelStyles } from "./utils";

const Container = styled.div`
  display: flex;
  padding: 1rem 0.5rem;
  flex-direction: column;

  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.surfaceAchievements};
`;

const Header = styled.div<{ $isOpen: boolean }>`
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0 0.5rem;

  & > p {
    flex: 1;
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.875rem;
    font-weight: 700;
    margin-left: 0.5rem;
  }

  & > svg {
    transform: rotate(${({ $isOpen }) => ($isOpen ? 270 : 90)}deg);
    transition: transform 300ms;
  }
`;

const TripleLevel = styled.div`
  position: relative;
  width: 2.52rem;
  height: 1.88rem;

  & > span {
    position: absolute;

    top: 50%;
    left: 60%;
    transform: translate(-50%, -50%);

    font-size: 0.6rem;
    font-weight: 500;
  }
  & > svg {
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.8);

    &:first-of-type {
      left: 30%;
      ${getLevelStyles("disabled")}
    }
    &:nth-of-type(2) {
      left: 45%;
      ${getLevelStyles("disabled")}
    }
    &:last-of-type {
      left: 60%;
    }
  }
`;

const NumberAchievements = styled.div`
  font-size: 1rem;
  font-weight: 900;

  span {
    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
    }
    &:last-of-type {
      color: ${({ theme }) => theme.colors.secondaryText};
    }
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  margin-top: 0.5rem;

  & > p {
    color: ${({ theme }) => theme.colors.secondaryText};
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 140%;
    padding: 0 0.5rem;
  }
`;

const Achievements = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.75rem;
  & > div {
    padding: 0 0.5rem;
  }
`;

const PrimeAchievements = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.75rem;
  padding: 0.5rem !important;

  border-radius: 0.75rem;
  border: 1px solid #ecdedd;
  background: rgba(251, 249, 248, 0.83);
`;

const Achievement = {
  Container: styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    user-select: none;
  `,

  Image: styled.div<{ $type: AchievementType }>`
    position: relative;

    width: 3.125rem;
    height: 3.75rem;

    border-radius: 0.75rem;
    padding: 0.25rem;

    background: ${({ theme, $type }) => theme.colors.achievements[$type]};
    border: 1px solid ${({ theme }) => theme.colors.black};

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  Title: styled.div`
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.75rem;
    font-weight: 600;
  `,

  Levels: styled.div`
    display: flex;
    gap: 0.75rem;
    & > div {
      &:last-of-type {
        &::after {
          display: none;
        }
      }
    }
  `,

  Level: styled.div<{ $completed: boolean; $level: number; $prevCompleted: boolean }>`
    position: relative;

    cursor: pointer;

    display: flex;
    gap: 0.75rem;
    & > svg {
      ${({ $level, $completed }) => getLevelStyles($completed ? $level : "disabled")}
      z-index: 10;
    }
    & > span {
      position: absolute;

      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      color: ${({ theme }) => theme.colors.black};
      font-size: 0.81531rem;
      font-weight: 500;
      z-index: 11;
    }

    &::after {
      content: "";
      position: absolute;
      width: 0.875rem;
      height: 0.50956rem;
      background-color: ${({ theme, $prevCompleted }) =>
        $prevCompleted ? theme.colors.achievements.divider : theme.colors.achievements.levels.disabled.background};

      top: 50%;
      right: -0.75rem;
      transform: translate(0, -50%);
      z-index: 9;
    }
  `,
};

export default {
  Container,
  Header,
  TripleLevel,
  NumberAchievements,
  Body,
  Achievements,
  Achievement,
  PrimeAchievements,
};
